import React, { useEffect, useState } from "react";
// react-bootstrap components
import { Card, Form, Container, Row, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router";
import { apiService } from "../../../service/ApiService";
import { notificationService } from "../../../service/NotificationService";
import CreateButton from "components/Buttons/CreateButton";
import EditButton from "components/Buttons/EditButton";
import GeneralStoreSelect from "components/DropDowns/GeneralStoreSelect";
import CategorySelect from "components/DropDowns/CategorySelect";

import { useTranslation } from "react-i18next";

function CategoryPage() {
  const {
    t,
  } = useTranslation();

  const backRoute = "/admin/categories";
  const history = useHistory();
  const { id } = useParams();
  const [storeId, setStoreId] = useState(null);
  const [categoryParentId, setCategoryParentId] = useState(null);
  const [categoryName, setCategoryName] = useState("");
  const [categoryFontSize, setCategoryFontSize] = useState(15);
  const [categoryColor, setCategoryColor] = useState("#28c76f");
  const [categoryOrder, setCategoryOrder] = useState(0);
  const [categoryDeleted, setCategoryDeleted] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);

  const handleStoreId = (id) => {
    setStoreId(id);
  };

  const handleScroll = (e) => {
    e.target.blur();
  }

  useEffect(() => {
    if (!id) return;
    apiService
      .get(`api/v1/categories/${id}`)
      .then((category) => {
        fillFields(category);
      })
      .catch((error) => {
        notificationService.notifyError(error.message);
        history.push(backRoute);
      });
  }, []);

  const handleCategoryChange = (categoryId) => {
    setCategoryParentId(categoryId);
  };

  const save = () => {
    setIsDisabled(true);
    const category = {
      name: categoryName,
      fontSize: categoryFontSize,
      color: categoryColor ? categoryColor : "ffffff",
      order: categoryOrder ? categoryOrder : 0,
      storeId: storeId,
      parentId: categoryParentId,
      deleted: categoryDeleted,
    };

    if (id) {
      apiService
        .putJson(`api/v1/categories/${id}`, category)
        .then((resp) => {
          notificationService.notifySuccess(t("messages.categorySavedSuccessfully"));
          history.push(backRoute);
          setIsDisabled(false);
        })
        .catch((error) => {
          setErrorMessage(error.message);
          notificationService.notifyError(error.message);
          setIsDisabled(false);
        });
    } else {
      apiService
        .postJson("api/v1/categories", category)
        .then((resp) => {
          notificationService.notifySuccess(t("messages.categoryCreatedSuccessfully"));
          history.push(backRoute);
          setIsDisabled(false);
        })
        .catch((error) => {
          setErrorMessage(error.message);
          notificationService.notifyError(error.message);
          setIsDisabled(false);
        });
    }
  };

  const fillFields = (category) => {
    setCategoryName(category.name);
    setCategoryFontSize(category.fontSize);
    setCategoryColor(category.color);
    setCategoryOrder(category.order);
    setCategoryDeleted(category.deleted);
    setCategoryParentId(category.parentId);
  };

  return (
    <>
      <Container fluid>
        <Row>
          <Col md="12">
            <Card className="stacked-form">
              <Card.Header>
                <Card.Title as="h4">{id ? t("pages.titles.editCategory") : t("pages.titles.createCategory")}</Card.Title>
              </Card.Header>
              <Card.Body>
                {errorMessage ? <div style={{ color: "crimson" }}>{errorMessage}</div> : null}
                <Form action="#" method="#">
                  <Row>
                    <Col>
                      <Form.Group>
                        <label>{t("common.labels.designation")}</label>
                        <Form.Control
                          placeholder={t("common.labels.designation")}
                          required={true}
                          type="text"
                          value={categoryName}
                          onChange={(event) => setCategoryName(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group>
                        <label>{t("common.labels.fontSizeDetailed")}</label>
                        <Form.Control
                          placeholder={t("common.labels.fontSizeDetailed")}
                          required={true}
                          type="number"
                          value={categoryFontSize}
                          onChange={(event) => setCategoryFontSize(event.target.value)}
                          onWheel={handleScroll}
                          min="0"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Group>
                        <label>{t("common.labels.color")}</label>
                        <Form.Control
                          placeholder={t("common.labels.color")}
                          required={true}
                          type="color"
                          value={categoryColor}
                          onChange={(event) => setCategoryColor(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group>
                        <label>{t("common.labels.order")}</label>
                        <Form.Control
                          placeholder={t("common.labels.order")}
                          required={true}
                          type="number"
                          value={categoryOrder}
                          onChange={(event) => setCategoryOrder(event.target.value)}
                          min="0"
                          onWheel={handleScroll}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <GeneralStoreSelect title={t("common.labels.store")} disabled={true} selectedStoreId={handleStoreId} />
                    </Col>
                    <Col>
                      <CategorySelect title={t("common.labels.parentCategory")} defaultValue={categoryParentId} handler={handleCategoryChange} id={id} />
                    </Col>
                  </Row>
                  <Row>
                    <Col md="1">
                      <Form.Group>
                        <label className="d-flex align-items-center">
                          <Form.Check type="switch" id="switch-1" checked={categoryDeleted} onChange={(e) => setCategoryDeleted(e.target.checked)} />
                          <span className="ml-1">{t("common.labels.inactive")}</span>
                        </label>
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
                <Row className="float-right">
                  <Col>{id ? <EditButton handler={save} disabled={isDisabled} /> : <CreateButton handler={save} disabled={isDisabled} />}</Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default CategoryPage;
